<template>
  <div>
    <b-row>
      <b-container>
        <h1 class="text-center py-2">
          {{ labels.title }}
        </h1>
      </b-container>
    </b-row>
    <b-row>
      <b-container v-if="!showMetrics">
        <h4 class="text-center border-bottom">
          {{ labels.subtitle }}
        </h4>
        <b-col md="8" class="mx-auto">
          <ul>
            <li v-for="(item, idx) in labels.instructive" :key="idx">
              {{ item }}
            </li>
          </ul>
        </b-col>
      </b-container>
    </b-row>
    <b-row v-if="!isLoading">
      <div id="paginationButtons">
        <md-button class="md-accent prev-page" :md-ripple="false" @click="prevPage()" :disabled="currentPage < 1">
          <font-awesome-icon :icon="['fas', 'arrow-left']"/>
          <span>Anterior</span>
        </md-button>
        <md-button class="md-accent next-page" :md-ripple="false" @click="nextPage()" :disabled="currentPage == lastPage">
          <span>Siguiente</span>
          <font-awesome-icon :icon="['fas', 'arrow-right']"/>
        </md-button>
      </div>
      <md-button class="md-fab md-fab-bottom-right md-fixed" id="filterButton" @click="toggleFilters()" :class="{active: showFilters}">
        <font-awesome-icon :icon="['fas', 'filter']" v-if="!showFilters"/>
        <font-awesome-icon :icon="['fas', 'times']" v-if="showFilters"/>
      </md-button>
      <md-button class="md-fab md-fab-bottom-right md-fixed" id="metricsButton" @click="toggleMetrics()" :class="{active: showFilters}">
        <font-awesome-icon :icon="['fas', 'angle-right']" v-if="!showMetrics"/>
        <font-awesome-icon :icon="['fas', 'table']" v-if="showMetrics"/>
      </md-button>
      <md-button  v-if="showMetrics" class="md-fab md-fab-bottom-right md-fixed" id="graphsButton" @click="toggleGraphs()" :class="{active: showGraphs}">
        <font-awesome-icon :icon="['fas', 'chart-pie']" v-if="!showGraphs"/>
        <font-awesome-icon :icon="['fas', 'times']" v-if="showGraphs"/>
      </md-button>
      <md-list id="filterNav" class="md-elevation-11" :class="{active: showFilters}">
      <md-subheader >{{labels.filters}}</md-subheader>
      <md-list-item v-for="(item,idx) in Object.keys(posibleFilters)" :key="idx">
        <md-checkbox v-model="activeFilters" :value="posibleFilters[item]" />
        <span class="md-list-item-text">{{item}}</span>
      </md-list-item>
    </md-list>
      <b-container v-if="!isEmpty" class="pb-5" :class="{'show-metrics': showMetrics}">
        <h4 class="text-center">
          {{ labels.info }}
        </h4>
        <b-row class="d-flex justify-content-between p-2">
        <div> <h5 class="d-inline pr-4">Fecha de venta:</h5>
        <date-range-picker
          v-model="dateRange"
          :ranges="rangeFalse" @update="setDate()"></date-range-picker></div>
        <md-button v-on:click="deleteFilters" class="md-flat md-accent"><h6>Borrar Filtros</h6></md-button>
        </b-row>
          
        
        <md-table
          md-card md-dense 
          id="metricsTable"
        >
          <md-table-row>
            <md-table-head v-show="activeFilters.includes('CLIENTE')"><md-button @click="showOptions('CLIENTE')">{{labels.cliente}}  </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('LOTES')"> <md-button @click="showOptions('LOTES')">{{labels.lotes}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('SACOS')"> <md-button @click="showOptions('SACOS')">{{labels.sacos}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('KILOS')"> <md-button @click="showOptions('KILOS')">{{labels.kilos}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('DENOMINACION')"> <md-button @click="showOptions('DENOMINACION')">{{labels.denominacion}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('PRODUCTO')"> <md-button @click="showOptions('PRODUCTO')">{{labels.producto}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('SUBPRODUCTO')"> <md-button @click="showOptions('SUBPRODUCTO')">{{labels.subproducto}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('MATERIAL')"> <md-button @click="showOptions('MATERIAL')">{{labels.material}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('ORGANIZACION')"> <md-button @click="showOptions('ORGANIZACION')">{{labels.organizacion}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('EMBARQUE')"> <md-button @click="showOptions('EMBARQUE')">{{labels.embarque}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('FECHAVENTA')"> <md-button @click="showOptions('FECHAVENTA')">{{labels.fechaventa}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('FACTURACION')"> <md-button @click="showOptions('FACTURACION')">{{labels.facturacion}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('FECHACOMPRA')"> <md-button @click="showOptions('FECHACOMPRA')">{{labels.fechacompra}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('COBERTURA')"> <md-button @click="showOptions('COBERTURA')">{{labels.cobertura}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('PRIMAFTUSD')"> <md-button @click="showOptions('PRIMAFTUSD')">{{labels.primaftusd}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('PRIMAORG')"> <md-button @click="showOptions('PRIMAORG')">{{labels.primaorg}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('BOLSAVENTA')"> <md-button @click="showOptions('BOLSAVENTA')">{{labels.bolsaventa}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('BOLSACOMPRA')"> <md-button @click="showOptions('BOLSACOMPRA')">{{labels.bolsacompra}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('DIFERENCIALVENTA')"> <md-button @click="showOptions('DIFERENCIALVENTA')">{{labels.diferencialventa}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('FIJACIONBOLSA')"> <md-button @click="showOptions('FIJACIONBOLSA')">{{labels.fijacionbolsa}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('COSTOMINCTVS')"> <md-button @click="showOptions('COSTOMINCTVS')">{{labels.costominctvs}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('IGCOBERTURA')"> <md-button @click="showOptions('IGCOBERTURA')">{{labels.igcobertura}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('IEXPOUSD')"> <md-button @click="showOptions('IEXPOUSD')">{{labels.iexpousd}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('IFINALUSD')"> <md-button @click="showOptions('IFINALUSD')">{{labels.ifinalusd}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('IEXPOCOP')"> <md-button @click="showOptions('IEXPOCOP')">{{labels.iexpocop}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('IFINALCOP')"> <md-button @click="showOptions('IFINALCOP')">{{labels.ifinalcop}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('PRIMAFT')"> <md-button @click="showOptions('PRIMAFT')">{{labels.primaft}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('RP140')"><md-button @click="showOptions('RP140')">{{labels.rp140}}  </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('RP')"> <md-button @click="showOptions('RP')">{{labels.rp}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('TRMCOMPRA')"> <md-button @click="showOptions('TRMCOMPRA')">{{labels.trmcompra}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('COSTOLIBRAS')"> <md-button @click="showOptions('COSTOLIBRAS')">{{labels.costolibras}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('COSTOCONT')"> <md-button @click="showOptions('COSTOCONT')">{{labels.costocont}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('RELIQUIDACION')"> <md-button @click="showOptions('RELIQUIDACION')">{{labels.reliquidacion}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('COSTOTOTAL')"> <md-button @click="showOptions('COSTOTOTAL')">{{labels.costototal}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('UTCTVUSD')"> <md-button @click="showOptions('UTCTVUSD')">{{labels.utctvusd}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('UTCOP')"> <md-button @click="showOptions('UTCOP')">{{labels.utcop}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('COSTOS')"> <md-button @click="showOptions('COSTOS')">{{labels.costos}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('VRCOMPRA')"> <md-button @click="showOptions('VRCOMPRA')">{{labels.vrcompra}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('VRCOMPRASACO')"> <md-button @click="showOptions('VRCOMPRASACO')">{{labels.vrcomprasaco}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('VRCALCSACO')"> <md-button @click="showOptions('VRCALCSACO')">{{labels.vrcalcsaco}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('DIFCOMPRA')"> <md-button @click="showOptions('DIFCOMPRA')">{{labels.difcompra}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('DIFCOMPRACTVS')"> <md-button @click="showOptions('DIFCOMPRACTVS')">{{labels.difcompractvs}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('DIFVENTACTVS')"> <md-button @click="showOptions('DIFVENTACTVS')">{{labels.difventactvs}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('UTPERDIFERENCIAL')"> <md-button @click="showOptions('UTPERDIFERENCIAL')">{{labels.utperdiferencial}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('UTCONTABLE')"> <md-button @click="showOptions('UTCONTABLE')">{{labels.utcontable}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('UTDIFERENCIAL')"> <md-button @click="showOptions('UTDIFERENCIAL')">{{labels.utdiferencial}} </md-button> </md-table-head>
            <md-table-head v-show="activeFilters.includes('DIFERENCIA')"> <md-button @click="showOptions('DIFERENCIA')">{{labels.diferencia}} </md-button> </md-table-head>
          </md-table-row>
          <md-table-row
            v-for="(item,idx) in dataToDisplay" :key="idx" class="not-cursor">
            <md-table-cell v-if="activeFilters.includes('CLIENTE')">
              {{ item.arrCalculos.CLIENTE }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('LOTES')">
              {{ item.arrCalculos.LOTES}}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('SACOS')">
              {{ item.arrCalculos.SACOS }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('KILOS')">
              {{  item.arrCalculos.KILOS }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('DENOMINACION')">
              {{ item.arrCalculos.DENOMINACION }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('PRODUCTO')">
              {{ item.arrCalculos.PRODUCTO }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('SUBPRODUCTO')">
              {{ item.arrCalculos.SUBPRODUCTO }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('MATERIAL')">
              {{ item.arrCalculos.MATERIAL }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('ORGANIZACION')">
            {{ item.arrCalculos.ORGANIZACION }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('EMBARQUE')">
            {{ item.arrCalculos.EMBARQUE }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('FECHAVENTA')">
            {{ item.arrCalculos.FECHAVENTA }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('FACTURACION')">
            {{  item.arrCalculos.FACTURACION }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('FECHACOMPRA')">
            {{ item.arrCalculos.FECHACOMPRA }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('COBERTURA')">
            {{ item.arrCalculos.COBERTURA }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('PRIMAFTUSD')">
            {{ item.arrCalculos.PRIMAFTUSD }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('PRIMAORG')">
            {{ item.arrCalculos.PRIMAORG }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('BOLSAVENTA')">
            {{ item.arrCalculos.BOLSAVENTA }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('BOLSACOMPRA')">
            {{ item.arrCalculos.BOLSACOMPRA }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('DIFERENCIALVENTA')">
            {{ item.arrCalculos.DIFERENCIALVENTA }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('FIJACIONBOLSA')">
            {{ item.arrCalculos.FIJACIONBOLSA }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('COSTOMINCTVS')">
            {{ item.arrCalculos.COSTOMINCTVS }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('IGCOBERTURA')">
            {{ item.arrCalculos.IGCOBERTURA }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('IEXPOUSD')">
            {{ item.arrCalculos.IEXPOUSD }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('IFINALUSD')">
            {{ item.arrCalculos.IFINALUSD }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('IEXPOCOP')">
            {{ item.arrCalculos.IEXPOCOP }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('IFINALCOP')">
            {{ item.arrCalculos.IFINALCOP }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('PRIMAFT')">
            {{ item.arrCalculos.PRIMAFT }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('RP140')">
            {{ item.arrCalculos.RP140 }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('RP')">
            {{ item.arrCalculos.RP }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('TRMCOMPRA')">
            {{ parseFloat(item.arrCalculos.TRMCOMPRA.replace('.','').replace(',','.')) }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('COSTOLIBRAS')">
            {{ item.arrCalculos.COSTOLIBRAS }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('COSTOCONT')">
            {{ item.arrCalculos.COSTOCONT }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('RELIQUIDACION')">
            {{ item.arrCalculos.RELIQUIDACION }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('COSTOTOTAL')">
            {{ item.arrCalculos.COSTOTOTAL }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('UTCTVUSD')">
            {{ item.arrCalculos.UTCTVUSD }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('UTCOP')">
            {{ item.arrCalculos.UTCOP }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('COSTOS')">
            {{ item.arrCalculos.COSTOS }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('VRCOMPRA')">
            {{ item.arrCalculos.VRCOMPRA }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('VRCOMPRASACO')">
            {{ item.arrCalculos.VRCOMPRASACO }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('VRCALCSACO')">
            {{ item.arrCalculos.VRCALCSACO }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('DIFCOMPRA')">
            {{ item.arrCalculos.DIFCOMPRA }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('DIFCOMPRACTVS')">
            {{ item.arrCalculos.DIFCOMPRACTVS }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('DIFVENTACTVS')">
            {{ item.arrCalculos.DIFVENTACTVS }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('UTPERDIFERENCIAL')">
            {{ item.arrCalculos.UTPERDIFERENCIAL }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('UTCONTABLE')">
            {{ item.arrCalculos.UTCONTABLE }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('UTDIFERENCIAL')">
            {{ item.arrCalculos.UTDIFERENCIAL }}
            </md-table-cell>

            <md-table-cell v-if="activeFilters.includes('DIFERENCIA')">
            {{ item.arrCalculos.DIFERENCIA }}
            </md-table-cell>
          </md-table-row>
          <md-table-row>
            <md-table-cell v-show="activeFilters.includes('CLIENTE')"> </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('LOTES')">  </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('SACOS')"> {{totals.SACOS }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('KILOS')"> {{totals.KILOS }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('DENOMINACION')">  </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('PRODUCTO')">  </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('SUBPRODUCTO')">  </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('MATERIAL')">  </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('ORGANIZACION')">  </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('EMBARQUE')">  </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('FECHAVENTA')">  </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('FACTURACION')"> {{totals.FACTURACION }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('FECHACOMPRA')"> </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('COBERTURA')"> {{ totals.COBERTURA }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('PRIMAFTUSD')"> {{ totals.PRIMAFTUSD }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('PRIMAORG')"> {{ totals.PRIMAORG }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('BOLSAVENTA')"> {{ totals.BOLSAVENTA }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('BOLSACOMPRA')"> {{ totals.BOLSACOMPRA }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('DIFERENCIALVENTA')"> {{ totals.DIFERENCIALVENTA }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('FIJACIONBOLSA')"> {{ totals.FIJACIONBOLSA }}  </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('COSTOMINCTVS')"> {{ totals.COSTOMINCTVS }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('IGCOBERTURA')"> {{ totals.IGCOBERTURA }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('IEXPOUSD')"> {{ totals.IEXPOUSD }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('IFINALUSD')"> {{ totals.IFINALUSD }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('IEXPOCOP')"> {{ totals.IEXPOCOP }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('IFINALCOP')"> {{ totals.IFINALCOP }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('PRIMAFT')"> {{ totals.PRIMAFT }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('RP140')"> {{ totals.RP140 }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('RP')"> {{ totals.RP }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('TRMCOMPRA')"> {{ totals.TRMCOMPRA }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('COSTOLIBRAS')"> {{ totals.COSTOLIBRAS }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('COSTOCONT')"> {{ totals.COSTOCONT }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('RELIQUIDACION')"> {{ totals.RELIQUIDACION }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('COSTOTOTAL')"> {{ totals.COSTOTOTAL }}  </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('UTCTVUSD')"> {{ totals.UTCTVUSD }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('UTCOP')"> {{ totals.UTCOP }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('COSTOS')"> {{ totals.COSTOS }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('VRCOMPRA')"> {{ totals.VRCOMPRA }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('VRCOMPRASACO')"> {{ totals.VRCOMPRASACO }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('VRCALCSACO')"> {{ totals.VRCALCSACO }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('DIFCOMPRA')"> {{ totals.DIFCOMPRA }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('DIFCOMPRACTVS')"> {{ totals.DIFCOMPRACTVS }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('DIFVENTACTVS')"> {{ totals.DIFVENTACTVS }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('UTPERDIFERENCIAL')"> {{ totals.UTPERDIFERENCIAL }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('UTCONTABLE')"> {{ totals.UTCONTABLE }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('UTDIFERENCIAL')"> {{ totals.UTDIFERENCIAL }} </md-table-cell>
            <md-table-cell v-show="activeFilters.includes('DIFERENCIA')"> {{ totals.DIFERENCIA }} </md-table-cell>
          </md-table-row>
        </md-table>
        <b-col
          md="6"
          class="mx-auto empty-table pt-4"
          v-if="searched.length == 0 && invoices.length > 0 && !isLoading"
        >
          <h3>{{labels.notFound}}</h3>
          <p>
            {{labels.notFoundMessage}}:
            <span>{{ search }}</span>
          </p>
        </b-col>
      </b-container>
      <b-container v-else>
        <b-col md="2" class="mx-auto">
          <div class="success-svg mb-4" :class="{ active: isEmpty }">
            <img src="../../assets/imgs/file-2.svg" alt="warning" />
          </div>
        </b-col>
        <b-col md="12" class="justify-content-around">
          <span id="message" v-if="isEmpty">{{ labels.empty }}</span>
        </b-col>
      </b-container>
      <b-container v-show="showMetrics" class="metrics">
        <md-table
            v-model="summary"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            md-card>

            <md-table-row>
              <md-table-head>{{ labels.producto }}</md-table-head>
              <md-table-head>{{ labels.utctvusd }}  </md-table-head>
              <md-table-head>{{ labels.utcop }}</md-table-head>
              <md-table-head> {{ labels.difcompra }}  </md-table-head>
              <md-table-head> {{ labels.difcompractvs }}  </md-table-head>
              <md-table-head> {{ labels.difventactvs }}  </md-table-head>
              <md-table-head> {{ labels.utperdiferencial }}  </md-table-head>
              <md-table-head> {{ labels.utcontable }}  </md-table-head>
              <md-table-head> {{ labels.utdiferencial }}  </md-table-head>
              <md-table-head> {{ labels.diferencia }}  </md-table-head>
            </md-table-row>

            <md-table-row v-for="(item,idx) in summary" :key="idx">

              <md-table-cell>
                {{ item.PRODUCTO }}
              </md-table-cell>

              <md-table-cell>
                {{ thoSeparator(item.UTCTVUSD) }}
              </md-table-cell>

              <md-table-cell>
                {{ thoSeparator(item.UTCOP) }}
              </md-table-cell>

              <md-table-cell>
                {{ thoSeparator(item.DIFCOMPRA) }}
              </md-table-cell>

              <md-table-cell>
                {{ thoSeparator(item.DIFCOMPRACTVS) }}
              </md-table-cell>

              <md-table-cell>
                {{ thoSeparator(item.DIFVENTACTVS) }}
              </md-table-cell>

              <md-table-cell>
                {{ thoSeparator(item.UTPERDIFERENCIAL) }}
              </md-table-cell>

              <md-table-cell>
                {{ thoSeparator(item.UTCONTABLE) }}
              </md-table-cell>

              <md-table-cell>
                {{ thoSeparator(item.UTDIFERENCIAL) }}
              </md-table-cell>

              <md-table-cell>
                {{ thoSeparator(item.DIFERENCIA) }}
              </md-table-cell>
            </md-table-row>
          </md-table>
          <b-row v-if="showGraphs" class="metrics" :class="{'metrics-active': showGraphs}">
        <Metrics :data-summary="summary"/>
      </b-row>
      </b-container>
      <md-dialog :md-active.sync="showDialog">
        <md-dialog-title>{{colToFilter}}</md-dialog-title>
        <md-dialog-content>
          <md-list>
      <md-list-item v-for="(item, idx) in colFilters" :key="idx">
        <md-checkbox v-model="valuesToFilter[colToFilter]" :value="item" />
        <span class="md-list-item-text">{{item}}</span>
      </md-list-item>
    </md-list>
        </md-dialog-content>
    <md-dialog-actions>
    <md-button class="md-primary" @click="updateSearchedMethod()">Guardar</md-button>
      </md-dialog-actions>
      </md-dialog>
    </b-row>
    <b-row v-else>
      <b-col md="12" lg="12" class="p-4 mx-audo">
        <div class="text-center">
          <b-spinner></b-spinner>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Invoice from "@/services/Invoice";
import Metrics from "@/components/analytics/Metrics";
import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'


const toLower = (text) => {
  return text.toString().toLowerCase();
};
const searchByLocated = (items, term) => {
  if (term) {
    return items.filter((item) =>
      toLower(item.arrCalculos['LOTES']).includes(toLower(term))
    );
  }
  return items;
};
const updateSearched = (docs, activeCols, filterValues) =>{
  if(activeCols.length > 0 ){
        let anyFilterSet = false
        activeCols.forEach(col => {
        if(filterValues[col].length > 0){
            anyFilterSet = true
          }
        })
        if(anyFilterSet){
        let filtered = []

        filtered = docs.filter( function(doc){
          for(let col in filterValues){
            if(activeCols.includes(col) && filterValues[col].length > 0){
              if(toLower(doc.arrCalculos[col]) == undefined || !filterValues[col].includes(doc.arrCalculos[col])) 
                return false
            }
          }
          return true
          })
        return filtered
        }
        else{
          return docs
        }
  }else{
    return docs
  }
    };
export default {
  name: "List",
  components: {
    Metrics,
    DateRangePicker
  },
  data() {
    return {
    currentPage: 0,
    lastPage: 0,
    limitRows: 300,
    rangeFalse: false,
    dateRange: {
          startDate: '2020-01-02',
          endDate: '2021-01-01',
        },
    dataToDisplay: [],
    datePlaceholder: "Seleccione rango de fechas",
    currentSort: "cliente",
    currentSortOrder: "asc",
    invoices: [],
    searched: [],
    searchedByDate: [],
    search: null,
    isEmpty: false,
    isUpdating: false,
    isLoading: false,
    success: false,
    error: false,
    dialogItem: {},
    showMetrics: false,
    showGraphs: false,
    showDialog: false,
    showFilters: false,
    activeFilters: ['CLIENTE','LOTES','SACOS','KILOS', 'PRODUCTO'],
    posibleFilters: {
      'CLIENTE': 'CLIENTE',
      'No_LOTE': 'LOTES',
      'No_SACOS': 'SACOS',
      'KILOS': 'KILOS',
      'DENOMINACION': 'DENOMINACION',
      'PRODUCTO': 'PRODUCTO',
      'SUBPRODUCTO': 'SUBPRODUCTO',
      'MATERIAL': 'MATERIAL',
      'ORGANIZACION': 'ORGANIZACION',
      'FECHA EMBARQUE': 'EMBARQUE',
      'FECHA VENTA': 'FECHAVENTA',
      'PRECIO DE FACTURA EXPORTACIÓN USDc/Lb': 'FACTURACION',
      'FECHA COMPRA': 'FECHACOMPRA',
      'COBERTURA': 'COBERTURA',
      'Prima FT Usd/Lb': 'PRIMAFTUSD',
      'Prima Org.': 'PRIMAORG',
      'NIVEL BOLSA DÍA DE VENTA': 'BOLSAVENTA',
      'NIVEL BOLSA DÍA DE LA COMPRA': 'BOLSACOMPRA',
      'DIFERENCIAL DÍA DE LA VENTA': 'DIFERENCIALVENTA',
      'FIJACIÓN BOLSA Y/O V/R M/CDD': 'FIJACIONBOLSA',
      'COSTO MINIMO CAFÉ PAGO A COPERATIVA TOTAL EGRESOS CTVS/Lb': 'COSTOMINCTVS',
      'INGRESOS/GAST POR COBERTURA BOLSA': 'IGCOBERTURA',
      'INGRESO EXPO Usc/Lb': 'IEXPOUSD',
      'INGRESO FINAL': 'IFINALUSD',
      'Ingreso EXPO $': 'IEXPOCOP',
      'INGRESO FINAL COP': 'IFINALCOP',
      'PRIMA FT': 'PRIMAFT',
      'Reliquidación Pagada por valor menos de la condición 140': 'RP140',
      'Reliquidación pagada': 'RP',
      'TRM DÍA DE LA COMPRA': 'TRMCOMPRA',
      'COSTO DE CAFÉ EN LIBRAS': 'COSTOLIBRAS',
      'COSTO REAL CONTABILIDAD': 'COSTOCONT',
      'RELIQUIDACION': 'RELIQUIDACION',
      'TOTAL COSTO': 'COSTOTOTAL',
      'UTILIDAD CTV/LB': 'UTCTVUSD',
      'UTILIDAD EN COP': 'UTCOP',
      'COSTOS': 'COSTOS',
      'V/R DE COMPRA': 'VRCOMPRA',
      'V/R DE COMPRA POR SACO': 'VRCOMPRASACO',
      'V/R CALCULADA PARA LA COMPRA POR SACO': 'VRCALCSACO',
      'DIFERENCIAL DE COMPRA': 'DIFCOMPRA',
      'DIFERENCIAL DE COMPRAS EN CTVS': 'DIFCOMPRACTVS',
      'DIFERENCIAL DE VENTAS EN CTVS': 'DIFVENTACTVS',
      'UTILIDAD Y/O PERDIDA DIFERENCIAL': 'UTPERDIFERENCIAL',
      'UTILIDAD CONTABLE': 'UTCONTABLE',
      'UTILIDAD DIFERENCIAL': 'UTDIFERENCIAL',
      'DIFERENCIA': 'DIFERENCIA',
    },
    colFilters: [],
    colToFilter: null,
    valuesToFilter: {
       'CLIENTE': [],
      'LOTES': [],
      'SACOS': [],
      'KILOS': [],
      'DENOMINACION': [],
      'PRODUCTO': [],
      'SUBPRODUCTO': [],
      'MATERIAL': [],
      'ORGANIZACION': [],
      'EMBARQUE': [],
      'FECHAVENTA': [],
      'FACTURACION': [],
      'FECHACOMPRA': [],
      'COBERTURA': [],
      'PRIMAFTUSD': [],
      'PRIMAORG': [],
      'BOLSAVENTA': [],
      'BOLSACOMPRA': [],
      'DIFERENCIALVENTA': [],
      'FIJACIONBOLSA': [],
      'COSTOMINCTVS': [],
      'IGCOBERTURA': [],
      'IEXPOUSD': [],
      'IFINALUSD': [],
      'IEXPOCOP': [],
      'IFINALCOP': [],
      'PRIMAFT': [],
      'RP140': [],
      'RP': [],
      'TRMCOMPRA': [],
      'COSTOLIBRAS': [],
      'COSTOCONT': [],
      'RELIQUIDACION': [],
      'COSTOTOTAL': [],
      'UTCTVUSD': [],
      'UTCOP': [],
      'COSTOS': [],
      'VRCOMPRA': [],
      'VRCOMPRASACO': [],
      'VRCALCSACO': [],
      'DIFCOMPRA': [],
      'DIFCOMPRACTVS': [],
      'DIFVENTACTVS': [],
      'UTPERDIFERENCIAL': [],
      'UTCONTABLE': [],
      'UTDIFERENCIAL': [],
      'DIFERENCIA': [],
    }
  }
  },
  computed: {
    summary(){
      var summarySearched = []
      var miArr = [];
      for (var i = 0; i < this.searched.length; i++) {
          miArr[i] = this.searched[i].producto;
        }
      var arrProduct = [...new Set(miArr)];
      for (i = 0; i < arrProduct.length; i++) {
          var actualKey = arrProduct[i].toString();
          let arrSearched = {};
          for (var j = 0; j < this.searched.length; j++) {
            if (this.searched[j].producto == actualKey) {
              Object.entries(this.searched[j].arrCalculos).forEach(([key, value]) => {
                if(key!='PRODUCTO'){arrSearched[key] = parseFloat(arrSearched[key]||0)+parseFloat(value||0);}
                else{arrSearched[key] = actualKey}
              });
            }
          }
          summarySearched.push(arrSearched);
        }
      return summarySearched
    },
    totals(){
      var total1 = {};
      for (var i=0; i<this.searched.length; i++){
          Object.entries(this.searched[i].arrCalculos).forEach(([key, value]) => {
            total1[key] = parseFloat(total1[key]||0)+parseFloat(value||0);
          });
      }
      return total1
    },
    complement() {
      return this.$store.state.userRole == "COM";
    },
    labels() {
      if (this.$store.state._language == "es-ES") {
        return {
          title: "Plataforma Para La Visualización De Análisis de Rentabilidad",
          subtitle: "Instrucciones",
          instructive: [
            "Bienvenidos, lo invitamos a revisar la información de cada archivo de Liquidación FLO.",
          ],
          info: "Información de rentabilidad",
          searchbar: "Buscar por Nombre",
          cliente: "CLIENTE",
          lotes: "No_LOTE",
          sacos: "No_SACOS",
          kilos: "KILOS",
          denominacion: "DENOMINACION",
          producto: "PRODUCTO",
          subproducto: "SUBPRODUCTO",
          material: "MATERIAL",
          organizacion: "ORGANIZACION",
          embarque: "FECHA EMBARQUE",
          fechaventa: "FECHA VENTA",
          facturacion: "PRECIO DE FACTURA EXPORTACIÓN USDc/Lb",
          fechacompra: "FECHA COMPRA",
          cobertura: "COBERTURA",
          primaftusd: "Prima FT Usd/Lb",
          primaorg: "Prima Org.",
          bolsaventa: "NIVEL BOLSA DÍA DE VENTA",
          bolsacompra: "NIVEL BOLSA DÍA DE LA COMPRA",
          diferencialventa: "DIFERENCIAL DÍA DE LA VENTA",
          fijacionbolsa: "FIJACIÓN BOLSA Y/O V/R M/CDD",
          costominctvs: "COSTO MINIMO CAFÉ PAGO A COPERATIVA TOTAL EGRESOS CTVS/Lb",
          igcobertura: "INGRESOS/GAST POR COBERTURA BOLSA",
          iexpousd: "INGRESO EXPO Usc/Lb",
          ifinalusd: "INGRESO FINAL",
          iexpocop: "Ingreso EXPO $",
          ifinalcop: "INGRESO FINAL COP",
          primaft: "Prima FT",
          rp140: "Reliquidación Pagada por valor menos de la condición 140",
          rp: "Reliquidación pagada",
          trmcompra: "TRM DÍA DE LA COMPRA",
          costolibras: "COSTO DE CAFÉ EN LIBRAS",
          costocont: "COSTO REAL CONTABILIDAD",
          reliquidacion: "RELIQUIDACIÓN",
          costototal: "TOTAL COSTO",
          utctvusd: "UTILIDAD CTV/LB",
          utcop: "UTILIDAD EN COP",
          costos: "COSTOS",
          vrcompra: "V/R DE COMPRA",
          vrcomprasaco: "V/R DE COMPRA POR SACO",
          vrcalcsaco: "V/R CALCULADA PARA LA COMPRA POR SACO",
          difcompra: "DIFERENCIAL DE COMPRA",
          difcompractvs: "DIFERENCIAL DE COMPRAS EN CTVS",
          difventactvs: "DIFERENCIAL DE VENTAS EN CTVS",
          utperdiferencial: "UTILIDAD Y/O PERDIDA DIFERENCIAL",
          utcontable: "UTILIDAD CONTABLE",
          utdiferencial: "UTILIDAD DIFERENCIAL",
          diferencia: "DIFERENCIA",
          empty: "Aún no cuentas con documentos",
          invoiceInformation: "Información del documento",
          notFound: "No se encontraron liquidaciones FLO",
          notFoundMessage: "No hay documentos con esos filtros",
          close: "Cerrar",
          filters: "Filtros"
        };
      } else {
        return {
          title: "Invoice Visualization Platform",
          subtitle: "Instructions",
          instructive: [
            "Welcome to the platform for the visualization of invoices, we invite you to review the information of each invoice.",
          ],
          info: "Invoices Information",
          searchbar: "Search by Filing Number",
          locatedNumber: "Filing #",
          locatedDate: "Filing Date",
          invoiceDate: "Invoice Date",
          provider: "Provider",
          invoiceNumber: "Invoice #",
          currency: "Currency",
          beforeTax: "Value before taxes",
          iva: "Invoiced VAT",
          impo: "Impoconsumo",
          otherTax: "Other taxes",
          reteFuente: "RETEFUENTE",
          reteICA: "RETEICA",
          reteIVA: "RETEIVA",
          paymentValue: "Value to be paid",
          document: "Document",
          approved: "Status",
          comment: "Comments",
          payDate: "Payment Date",
          status: ["Pending", "Declined", "Approved"],
          empty: "You don't have invoices yet",
          invoiceInformation: "Invoice Information",
          notFound: "No invoices found",
          notFoundMessage: "There isn't invoices with that number",
          close: "Close"
        };
      }
    },
  },
  filters: {
    dateCell (value) {
      let dt = new Date(value)

      return dt.getDate()
    },
    date (val) {
      return val ? val.toLocaleString() : ''
    }
  },
  methods: {
    updateDataToDisplay(){
      let dataLength = this.searched.length
      this.lastPage = Math.floor(dataLength/this.limitRows)
      this.dataToDisplay = this.searched.slice(this.currentPage*this.limitRows,this.limitRows*(this.currentPage+1))
    },
    nextPage(){
      this.currentPage = this.currentPage + 1
      this.updateDataToDisplay()
    },
    prevPage(){
      this.currentPage = this.currentPage - 1
      this.updateDataToDisplay()
    },
    deleteFilters(){
      this.searched = this.invoices;
      this.dateRange= {
          startDate: '2020-01-02',
          endDate: '2021-12-31',
        },
      this.activeFilters= ['CLIENTE','LOTES','SACOS','KILOS', 'PRODUCTO']
    },    
    setDate(){
      this.searchedByDate = [];
      var date1 = this.dateRange.startDate.toLocaleDateString('es-CO').split("/")
      console.log(date1);
      var day1 = 0;
      day1 = parseInt(date1[0])+parseInt(date1[1])*30+parseInt(date1[2])*365;
      console.log('Start: '+day1)

      var date2 = this.dateRange.endDate.toLocaleDateString('es-CO').split("/")
      console.log(date2);
      var day2 = parseInt(date2[0])+parseInt(date2[1])*30+parseInt(date2[2])*365;
      console.log('End: '+day2)
      var date3;
      var day3=0;

      // // FECHA COMPRA APPROACH
      // for(var i=0;i<this.invoices.length;i++){
      //   date3 = this.invoices[i].arrCalculos.FECHACOMPRA.split("/")
      //   day3 = parseInt(date3[0])+parseInt(date3[1])*30+parseInt(date3[2])*365;
      //   if (day3>=day1 && day3<=day2){
      //     this.searchedByDate.push(this.invoices[i])
      //   }
      // }

      // FECHA VENTA APPROACH
      for(var i=0;i<this.invoices.length;i++){
        date3 = this.invoices[i].arrCalculos.FECHAVENTA.split("/")
        day3 = parseInt(date3[0])+parseInt(date3[1])*30+parseInt(date3[2])*365;
        if (day3>=day1 && day3<=day2){
          this.searchedByDate.push(this.invoices[i])
        }
      }
      this.searched = this.searchedByDate;
    },
    thoSeparator(value){
      return value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    toggleFilters(){
      this.showFilters = !this.showFilters
    },
    toggleMetrics(){
      this.showMetrics = !this.showMetrics
    },
    toggleGraphs(){
      this.showGraphs = !this.showGraphs
    },
    updateSearchedMethod(){
      //console.log(this.valuesToFilter)
      this.searched = updateSearched(this.searched, this.activeFilters, this.valuesToFilter)
      this.showDialog = false
      //console.log(this.searched)
    },
    showOptions(value){
      let arr = []
      this.invoices.forEach(element => {
        arr.push(element.arrCalculos[value])
      });
      let newSet = new Set([...arr]);
      this.colFilters = [...newSet];
      this.colToFilter = value;
      //console.log(this.colFilters);
      this.showDialog = true;
    },
    showInfo(id) {
      const currentIdx = this.invoices.findIndex((obj) => obj.id == id);
      this.dialogItem = this.invoices[currentIdx];
      this.showDialog = true;
    },
    download(id) {
      Invoice.download(id).then((response) => {
        const url = URL.createObjectURL(
          new Blob([response.data], {
            type: "application/pdf",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", id + ".pdf");
        document.body.appendChild(link);
        link.click();
      });
    },
    updateInvoice(id) {
      const newStatus = this.invoices.filter(obj => obj.id == id)[0].status
      Invoice.changeStatus(id, newStatus )
        .then(() => {
          // this.success = true;
        })
        .catch(() => {
          // console.log(error);
          // const currentInv = this.invoices.findIndex((obj) => obj.id == id);
          // this.invoices[currentInv].approved = !this.invoices[currentInv]
          //   .approved;

          // this.error = true;
        })
        .finally(() => {
          // this.isLoading = false;
        });
    },
    updateInvoicePayment(id) {
      const currentInv = this.invoices.findIndex((obj) => obj.id == id);
      const date = this.invoices[currentInv].date;
      // this.isLoading = true;
      Invoice.updatePaydate(id, date)
        .then(() => {})
        .catch(() => {
          //console.log(error);
          const currentInv = this.invoices.findIndex((obj) => obj.id == id);
          this.invoices[currentInv].payDate = null;

          // this.error = true;
        })
        .finally(() => {
          // this.isLoading = false;
        });
    },
    updateInvoiceComment(id){
      const currentInv = this.invoices.findIndex((obj) => obj.id == id);
      const comment = this.invoices[currentInv].comment;
       Invoice.updateComment(id,comment)
        .then(() => {
        })
        .catch(() => {
          //console.log(error);
          const currentInv = this.invoices.findIndex((obj) => obj.id == id);
          this.invoices[currentInv].comment = null;
        })
    },
    customSort(value) {
      console.log(value);
      // console.log("hola");
      // return value.sort((a, b) => {
      //   const sortBy = this.currentSort;

      //   if (this.currentSortOrder === "desc") {
      //     return a[sortBy].toString().localeCompare(b[sortBy].toString());
      //   }

      //   return b[sortBy].toString().localeCompare(a[sortBy].toString());
      // });
    },
    searchOnTable() {
      this.searched = searchByLocated(this.invoices, this.search);
    },
  },
  mounted() {
    this.isLoading = true;
    if (this.$store.state.userRole == "COM") {
      Invoice.getAll()
        .then((result) => {
          //console.log(result)
          this.invoices = result.data.companies;
          this.searched = this.invoices;
          if (this.invoices.length == 0) {
            this.isEmpty = true;
          }
          this.updateDataToDisplay()
        })
        .catch(() => {
          // console.log(error);
          this.error = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      Invoice.getAllByCompany(this.$store.state.companyId)
        .then((result) => {
          // console.log(result)
          this.invoices = result.data.invoices;
          this.searched = this.invoices;
          if (this.invoices.length == 0) {
            this.isEmpty = true;
          }
          this.updateDataToDisplay()
        })
        .catch(() => {
          // console.log(error);
          this.error = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
};
</script>

<style src="../main.css" scoped>
form {
  width: 100%;
}
</style>

